import {TheCrypt} from "../TheCrypt";

export interface IWinRatioConfig {
    readonly ratio: number;
    readonly duration: number;
    readonly type: string;
}

export interface IBigWinLevel extends IWinRatioConfig {
    readonly from: number;
    to: number;
    readonly id: number;
}

export interface IWinRatios {
    readonly normalWin: IWinRatioConfig[];
    readonly bigWin: IBigWinLevel[];
}

export class TheCryptWinConfig {

    public static TINY: string = "tiny";
    public static SMALL: string = "small";
    public static MEDIUM: string = "medium";
    public static LARGE: string = "large";
    public static BIG_WIN_01: string = "bigWin01";
    public static BIG_WIN_02: string = "bigWin02";
    public static BIG_WIN_03: string = "bigWin03";
    public static BIG_WIN_04: string = "bigWin04";
    public static BIG_WIN_05: string = "bigWin05";

    public static WIN_RATIOS: IWinRatios = {
        normalWin: [
            {
                ratio: 0,
                duration: 0.001,
                type: TheCryptWinConfig.TINY
            },
            {
                ratio: 1.5,
                duration: 0.001,
                type: TheCryptWinConfig.SMALL
            },
            {
                ratio: 3,
                duration: 0.5,
                type: TheCryptWinConfig.MEDIUM
            },
            {
                ratio: 5,
                duration: 1,
                type: TheCryptWinConfig.LARGE
            }
        ],
        bigWin: [
            {
                from: 15,
                to: 25,
                id: 1,
                ratio: 15,
                duration: 4.228,
                type: TheCryptWinConfig.BIG_WIN_01
            },
            {
                from: 25,
                to: 50,
                id: 2,
                ratio: 25,
                duration: 4.228,
                type: TheCryptWinConfig.BIG_WIN_02
            },
            {
                from: 50,
                to: 100,
                id: 3,
                ratio: 50,
                duration: 4.228,
                type: TheCryptWinConfig.BIG_WIN_03
            },
            {
                from: 100,
                to: 250,
                id: 4,
                ratio: 100,
                duration: 8.476,
                type: TheCryptWinConfig.BIG_WIN_04
            },
            {
                from: 250,
                to: 27000,
                id: 5,
                ratio: 250,
                duration: 8.476,
                type: TheCryptWinConfig.BIG_WIN_05
            }
        ]
    };

    public static getWinConfig(): IWinRatioConfig {
        const ratio: number = TheCrypt.model.winRatio;
        for (let index: number = TheCryptWinConfig.WIN_RATIOS.bigWin.length - 1; index >= 0; index--) {
            if (ratio >= TheCryptWinConfig.WIN_RATIOS.bigWin[index].ratio) {
                if ((index === 0) || (ratio >= TheCryptWinConfig.WIN_RATIOS.bigWin[index].from * 1.2)) {
                    return TheCryptWinConfig.WIN_RATIOS.bigWin[index];
                } else {
                    return TheCryptWinConfig.WIN_RATIOS.bigWin[index - 1];
                }
            }
        }
        for (let index: number = TheCryptWinConfig.WIN_RATIOS.normalWin.length - 1; index >= 0; index--) {
            if (ratio >= TheCryptWinConfig.WIN_RATIOS.normalWin[index].ratio) {
                return TheCryptWinConfig.WIN_RATIOS.normalWin[index];
            }
        }
        return TheCryptWinConfig.WIN_RATIOS.normalWin[0];
    }

    public static getBigWinLevels(ratio: number): IBigWinLevel[] {
        let levels: IBigWinLevel[] = [];
        const length: number = TheCryptWinConfig.WIN_RATIOS.bigWin.length;
        for (let index: number = 0; index < length; index++) {
            if (ratio >= TheCryptWinConfig.WIN_RATIOS.bigWin[index].ratio) {
                levels.push(TheCryptWinConfig.WIN_RATIOS.bigWin[index]);
            }
        }
        return levels;
    }

    public static getBigWinLevel(ratio: number): number {
        let level: number = -1;
        const length: number = TheCryptWinConfig.WIN_RATIOS.bigWin.length;
        for (let index: number = 0; index < length; index++) {
            if (ratio >= TheCryptWinConfig.WIN_RATIOS.bigWin[index].ratio) {
                level = index
            }
        }

        return level;
    }

    private static setLastConfig(winRatio: number, configs: IBigWinLevel[]): IBigWinLevel[] {
        let lastConfig = configs[configs.length - 1];
        if (lastConfig.from * 1.2 > winRatio && configs.length > 1) {
            configs.pop();
            return TheCryptWinConfig.setLastConfig(winRatio, configs);
        }

        lastConfig.to = winRatio;
        return configs;
    }
}
